import { render } from "./ProductsModal.vue?vue&type=template&id=73bdd8b0&scoped=true"
import script from "./ProductsModal.vue?vue&type=script&lang=js"
export * from "./ProductsModal.vue?vue&type=script&lang=js"

import "./ProductsModal.vue?vue&type=style&index=0&id=73bdd8b0&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73bdd8b0"]])

export default __exports__